
export default {
  created() {
  },
  mounted () {
    this.adjustViewScale()
    window.addEventListener('resize', this.onWindowResize, true);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    // 根据实际屏幕分辨率调整视图缩放
    onWindowResize() {
      this.adjustViewScale();
    },

    /**
     * 根据实际屏幕分辨率调整视图缩放
     */
    adjustViewScale() {
      // 设计稿：1920 * 1080
      // 设配目标：1920 * 1080 ( 1 : 1) | 3840* 2160 ( 2 : 2 ) | 7680 * 2160 ( 4 : 2)
      // 1.设计稿尺寸
      let orgWidth = 1920;
      let orgHeight = 1080;

      // 2.拿到当前设备（浏览器）的宽度
      let currentWidth = document.documentElement.clientWidth;
      let currentHeight = document.documentElement.clientHeight;

      // 3.计算缩放比率(屏幕过宽，根据高度计算缩放比例)
      if (currentWidth >= orgWidth / 2 && currentHeight >= orgHeight / 2) {
        let currentRatio = currentWidth / currentHeight;
        let targetRatio = orgWidth / orgHeight;
        let ratio = 1;
        // 原始屏幕水平居中，垂直不居中，所以在缩放之前必须先计算出垂直偏移
        let dy = (currentHeight - orgHeight) / 2;
        if (targetRatio <= currentRatio) {
          ratio = currentHeight / orgHeight;
        } else {
          ratio = currentWidth / orgWidth;
        }
        // console.log('##body.style-transform: ', dy, ratio)
        document.body.style = `transform: translateY(${dy}px) scale(${ratio}) translateY(10px) `;
      }
    }
  },
}
